<template>
  <div class="vxa-aside-track" v-loading="loading" ref="asideTrake">
    <div class="title" ref="trackTitleDom">
      <span>我的足迹</span>
      <i class="iconfont web-close-x" @click="closeWindow"></i>
    </div>
    <div class="trackContent" v-show="!isNull">
      <div class="counter" ref="counterDom">
        <span>{{ trackNum }}条记录</span>
        <xa-button type="primary" text @click="open2">
          <i class="iconfont web-shanchu"></i>
        </xa-button>
      </div>
      <div class="listContainer vxa-scrollbar-no-shadow">
        <div class="list" v-for="list in trackList" @click="linkTo(list.type, list.refId)" :key="list.id">
          <el-row>
            <el-col :span="isHaveInquiry ? 4 : 3" class="type-col">
              <xa-button type="primary" :style="{ 'background-color': getBackgroundByType(list.type) }">{{
                getLabelByType(list.type)
              }}</xa-button>
            </el-col>
            <el-col :span="isHaveInquiry ? 20 : 21" class="title-box">
              <el-row>
                <el-col :span="isHaveInquiry ? 18 : 19" class="title-col">
                  <div class="listTitle" v-line-clamp:22="2">{{ list.title }}</div>
                </el-col>
                <el-col :span="isHaveInquiry ? 6 : 5" class="time-col">
                  <span class="time">{{ $common.formatDate(list.releaseTime, 'YYYY-MM-DD') }}</span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="trackContent" v-show="isNull" style="padding-top: 180px">
      <vxa-no-info altText="暂无足迹" style="font-size: 16px"></vxa-no-info>
    </div>
  </div>
</template>

<script>
export default {
  name: 'vxa-aside-track',
  data() {
    return {
      loading: true,
      isNull: false,
      trackNum: '12',
      trackList: [],
      isHaveInquiry: false
    }
  },
  created() {
    this.getTrackM()
  },
  methods: {
    // 跳转内容
    linkTo(type, id) {
      var url = ''
      if (type == 1) {
        // path /rules/:id
        url = `/rules/${id}`
      } else if (type == 3) {
        // path: /affiches/:id
        url = `/affiches/${id}`
      } else if (type == 4) {
        // path: /reports/:id
        url = `/reports/${encodeURIComponent(id)}`
      } else if (type == 5) {
        // path: /violation-cases/:id
        url = `/violation-cases/${id}`
      } else if (type == 6) {
        // path: /inhope-FAQ/questions/:id
        url = `/inhope-FAQ/questions/${id}`
      } else if (type == 8) {
        // path: /ipo/:id
        url = `/ipo/${id}`
      } else if (type == 9) {
        // path: /investor/questions/:id
        url = `/investor/questions/${id}`
      } else if (type == 10) {
        // path: /STAR-ipo/:id
        url = `/STAR-ipo/${id}`
      } else if (type == 11) {
        // path: /inquiry-letters/:id
        url = `/inquiry-letters/${id}`
      } else if (type == 12) {
        // id最后一位是M 表示资本市场舆情
        // path: /sentiments/:id
        url = `/sentiments/${id}`
      } else if (type == 22) {
        // path: /stib-ipo/:id
        url = `/stib-ipo/${id}`
      } else if (type == 23) {
        // path: /bse-ipo/:id
        url = `/bse-ipo/${id}`
      }
      this.$common.openWindow(url)
    },
    open2() {
      this.$confirm('删除足迹, 是否继续?', '永久删除哦！', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.delTrack()
        })
        .catch(() => {
          this.$xaToast({ message: '已取消删除', type: 'info' })
        })
    },
    // 删除足迹
    delTrack() {
      this.$axios.user.delTrack().then(res => {
        this.$xaToast({ message: '足迹清除成功！', type: 'success' })
        this.isNull = true
      })
    },
    // 获取足迹
    getTrackM() {
      this.loading = true
      this.$axios.user
        .getTrack()
        .then(res => {
          this.loading = false
          this.trackList = res.data.returnObject ?? []
          // 是否包含问询函件类型的足迹
          this.isHaveInquiry = this.trackList.some(track => track.type === 11)
          this.trackNum = this.trackList.length
          if (this.trackNum == 0) {
            this.isNull = true
          } else {
            this.isNull = false
          }
        })
        .catch(err => {
          if (err.response && err.response.data.returnCode === 'B020202') {
            this.isNull = true
          }
          this.loading = false
        })
    },
    closeWindow() {
      this.$emit('isShow')
    },
    getBackgroundByType(type) {
      let background = ''
      switch (type) {
        case 1:
          background = '#90b8f4'
          break
        case 3:
          background = '#ffd091'
          break
        case 4:
          background = '#9ae6ed'
          break
        case 5:
        case 6:
        case 7:
        case 9:
          background = '#ffa691'
          break
        case 8:
        case 10:
        case 22:
        case 23:
          background = '#ffddb0'
          break
        case 11:
          background = '#9aa7db'
          break
        case 12:
          background = '#FFA9F0'
          break
      }
      return background
    },
    getLabelByType(type) {
      let label = ''
      switch (type) {
        case 1:
          label = '法规'
          break
        case 3:
          label = '公告'
          break
        case 4:
          label = '研报'
          break
        case 5:
          label = '案例'
          break
        case 6:
        case 7:
          label = '问答'
          break
        case 8:
        case 10:
        case 22:
        case 23:
          label = 'IPO'
          break
        case 9:
          label = 'e互动'
          break
        case 11:
          label = '问询函件'
          break
        case 12:
          label = '舆情'
          break
      }
      return label
    }
  }
}
</script>

<style lang="scss" scoped>
.vxa-aside-track {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  .title {
    padding: 0 16px;
    height: 45px;
    line-height: 45px;
    border-bottom: 1px solid #e3e3e3;
    font-size: 14px;
    color: rgba(50, 50, 50, 1);
    font-weight: bold;
    i {
      float: right;
      color: #8d8d8d;
      font-size: 20px;
      cursor: pointer;
    }
  }
  .trackContent {
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
    height: 0;
    .counter {
      padding: 0 16px;
      line-height: 24px;
      height: 24px;
      background: rgba(0, 0, 0, 0.03);
      .xa-button {
        float: right;
        padding: 0;
        height: 26px;
        min-width: 14px;
      }
      span {
        font-size: 12px;
        font-weight: normal;
        color: rgba(141, 141, 141, 1);
      }
      i {
        float: right;
        color: #bcbcbc;
        font-size: 12px;
        line-height: 24px;
        cursor: pointer;
      }
    }
    .listContainer {
      flex: 1;
      padding: 0 16px;
      width: 100%;
      height: 0;
      overflow: auto;
      .el-button.is-round {
        background: #d4b486;
        color: #fff;
        font-size: 14px;
        border: none;
        cursor: default;
      }
      .list {
        cursor: pointer;
        .type-col {
          padding: 12px 0;
          line-height: 1;
        }
        .title-col {
          font-size: 14px;
          color: rgba(50, 50, 50, 1);
          text-align: left;
        }
        .title-box {
          padding: 12px 0;
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        }
        .listTitle {
          &:hover {
            text-decoration: underline;
            color: #ffb148;
          }
        }
        .xa-button {
          font-size: 12px;
          color: #fff;
          padding: 3px 5px;
          min-width: 30px;
          height: 18px;
          border: 0;
          cursor: default;
        }
        .el-button--primary {
          background-color: #90b8f5;
        }
        .el-button--warning {
          background-color: #ffb148;
        }
        .time-col {
          text-align: right;
        }
        .time {
          font-size: 12px;
          color: rgba(174, 174, 174, 1);
        }
      }
    }
  }
}
</style>
